var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "263.57mm",
    height: "60.36mm",
    viewBox: "0 0 747.12 171.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_2-2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 88.08,
    width: 50.78,
    height: 83.01,
    rx: 6.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 61.37,
    y: 111.95,
    width: 50.78,
    height: 59.14,
    rx: 6.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 122.74,
    y: 60.35,
    width: 50.78,
    height: 110.73,
    rx: 6.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.77,62.92a17.55,17.55,0,0,0,15-8.47L69.58,65.51A17.57,17.57,0,1,0,102,60.43l35.26-29.06a17.59,17.59,0,1,0-3.9-4.3L98.29,56a17.58,17.58,0,0,0-26.56,4.15L44,49.06A17.58,17.58,0,1,0,26.77,62.92Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Capa_3",
    "data-name": "Capa 3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M420.41,85.6a84.85,84.85,0,0,1-21.28,57.22q-24.28,28-65.69,28t-65.57-28A84.81,84.81,0,0,1,246.58,85.6a88.13,88.13,0,0,1,5.76-30.54,85.28,85.28,0,0,1,15.41-26.8Q292,.24,333.44.24t65.69,28A85,85,0,0,1,420.41,85.6Zm-42.34,0a43.42,43.42,0,0,0-10.61-29.27q-13.6-15.75-34-15.75A43.19,43.19,0,0,0,308,48.63a43.87,43.87,0,0,0-16.26,21.45,45.18,45.18,0,0,0-2.77,15.52,44.26,44.26,0,0,0,10.61,29q13.14,15.87,33.91,15.87t34-15.75A43.86,43.86,0,0,0,378.07,85.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M539.36,39.76H505.54V165.1H464.7V39.76H431.45V5.05H539.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M747.12,165.1H706.28L694.67,72.94,656.75,165.1H640.54l-36.2-92.16L591,165.1H550.29L577,5.05h40.38l31.75,85.36L682.7,5.05h40.72Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoW);
export default __webpack_public_path__ + "static/media/logoW.25e37906c206e7e94d7dc8ca7f45794e.svg";
export { ForwardRef as ReactComponent };